import { render, staticRenderFns } from "./TsAudioRecorder.vue?vue&type=template&id=4f5792dc&scoped=true&"
import script from "./TsAudioRecorder.vue?vue&type=script&lang=js&"
export * from "./TsAudioRecorder.vue?vue&type=script&lang=js&"
import style0 from "./TsAudioRecorder.vue?vue&type=style&index=0&id=4f5792dc&scoped=true&lang=css&"
import style1 from "./TsAudioRecorder.vue?vue&type=style&index=1&id=4f5792dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5792dc",
  null
  
)

export default component.exports